export default "__VITE_ASSET__DCZshj9D__"